import Phaser from "phaser";
import { MovingObject } from "../entities/MovingObject";
import { GazePoint } from "../adapters/IGazeAdapter";
import { distance } from "../utils/Geometry";
import { randomRange } from "../utils/RNG";

export class ObjectSystem {
  private scene: Phaser.Scene;
  private objects: MovingObject[] = [];

  constructor(scene: Phaser.Scene) {
    this.scene = scene;
  }

  createObjects(count: number, gameW: number, gameH: number): MovingObject[] {
    this.destroyAll();
    for (let i = 0; i < count; i++) {
      const ox = randomRange(50, gameW - 50);
      const oy = randomRange(80, gameH - 50);
      this.objects.push(new MovingObject(this.scene, ox, oy));
    }
    return this.objects;
  }

  getObjects(): MovingObject[] {
    return this.objects;
  }

  updateActiveObject(gaze: GazePoint): MovingObject | null {
    let closest: MovingObject | null = null;
    let closestDist = Infinity;
    for (const obj of this.objects) {
      const d = distance(gaze.x, gaze.y, obj.x, obj.y);
      if (d < closestDist) {
        closestDist = d;
        closest = obj;
      }
    }
    for (const obj of this.objects) {
      obj.setActive(obj === closest);
    }
    if (closest) {
      closest.setPosition(gaze.x, gaze.y);
    }
    return closest;
  }

  respawn(obj: MovingObject, gameW: number, gameH: number): void {
    const margin = 60;
    obj.setPosition(
      randomRange(margin, gameW - margin),
      randomRange(margin + 50, gameH - margin)
    );
    obj.resetScored();
    obj.setActive(false);
  }

  destroyAll(): void {
    this.objects.forEach((o) => o.destroy());
    this.objects = [];
  }
}
